var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center box",class:{ reversed: _vm.reversed }},[_c('div',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))]),_c('div',{staticClass:"month"},[_vm._v(_vm._s(_vm.month))])])}
var staticRenderFns = []

export { render, staticRenderFns }